// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1380":"8eb32e1c863337ce","2888":"ea912c6230535d5f"}[chunkId] + ".css";
};